import './CancelSessionStyle.css'
import '../Deletepoup/DeletepoupStyle.css'
import React from 'react'
import Button from '../../Button/Button'
import TextArea from '../../TextArea/TextArea'

const CancelSession = ({ isActive, handleClose, onChange, reason, handleDiscard, handleSave, error }) => {
    return (
        <div className={`popupWrapper poupviewtab  ${isActive && "active"}`}>
            <div className="popupContainer Cancelpopupwrap">
                <div className="popupBody">
                    <span className="closebtn mb10">
                        <img src="/assets/svg/close.svg" alt="" onClick={handleClose} />
                    </span>
                    <div className="headingpoup">
                        <h3>Cancel Session</h3>
                    </div>
                    <div className="Cnacelsessioncontent flex-center">
                        <p className='text3 mb30'>Kindly state the reason for cancelling your call with this mentor</p>
                        <TextArea placeholder={'Example: Due to my unavailability on this day'} notImp={'true'} value={reason} onChange={onChange} errorMessage={error} />

                    </div>

                </div>
                <div className="popupHeader flex-center gap-10 mt-40">
                    <Button name={'Discard'} className={'GreyFillButton btncong active'} onClick={handleDiscard} />
                    <Button name={'Submit'} className={'BlueFillButton btncong active'} onClick={handleSave} />
                </div>
            </div>
        </div>
    )
}

export default CancelSession